<div class="relative transition-all duration-300"
  [class.z-[3000]]="isExpanded() || isComparisionExpanded() || isGroupExpanded()"
  [style.z-index]="(isExpanded() || isComparisionExpanded() || isGroupExpanded()) ? 3000 : 1" #containerRef
  appClickOutside (clickOutside)="onClickOutside()">
  @if(!isMobile()) {
  <!-- Top Container - Always Visible -->
  <div class="w-full">
    <!-- (click)="toggle()" -->
    <button #triggerRef
      class="w-full flex items-center justify-between px-4 rounded-lg transition-all duration-300 group border border-[#EAEAEA] dark:border-line bg-white dark:bg-surface-1 text-[#141437] dark:text-white hover:border-purple-400 dark:hover:border-line-strong hover:bg-white dark:hover:bg-surface-1/50 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 dark:focus:border-purple-400 gap-6"
      [class]="triggerPadding() + ' ' + (triggerClass || '')" type="button" [disabled]="disabled">
      <div class="flex items-center gap-6 flex-1">
        <!-- Date Range -->
        <div class="flex items-center gap-2 cursor-pointer" (click)="toggle(); toggleSection('range')">
          <app-icon name="calendar" class="w-4 h-4 text-purple-600 dark:text-purple-400"></app-icon>
          <div class="flex items-center gap-2">
            <span class="text-sm">{{ displayText() }}</span>
          </div>
        </div>

        @if(showComparison) {
        <!-- Divider -->
        <div class="h-6 w-px bg-purple-200 dark:bg-purple-500/20"></div>

        <!-- Comparison -->
        @if(comparisonRange()){
        <div class="flex items-center gap-2 cursor-pointer" (click)="toggleComparision(); toggleSection('comparison')">
          <app-icon name="chartNoAxesCombined" class="w-4 h-4 text-purple-600 dark:text-purple-400"></app-icon>
          <span class="text-sm">{{ comparisonLabel() }}</span>
          <span class="text-xs text-gray-600 dark:text-gray-400">({{ comparisonDates() }})</span>
        </div>
        } @if(!comparisonRange()){
        <div class="flex items-center gap-2 cursor-pointer" (click)="toggleComparision(); toggleSection('comparison')">
          <app-icon name="chartNoAxesCombined" class="w-4 h-4 text-gray-600 dark:text-gray-600"></app-icon>
          <span class="text-sm text-gray-500 dark:text-gray-500">No Comparison</span>
        </div>
        } } @if(showGroupBy) {
        <!-- Divider -->
        <div class="h-6 w-px bg-purple-200 dark:bg-purple-500/20"></div>

        <!-- Group By -->
        <div #groupByButton class="flex items-center gap-2 cursor-pointer"
          (click)="toggleGroup(); toggleSection('groupby')">
          <app-icon name="chartNoAxesCombined" class="w-4 h-4 text-purple-600 dark:text-purple-400"></app-icon>
          <span class="text-sm capitalize">Group by
            {{
            hideWeekDayUnit && ["week", "day", "hour"].includes(timeUnit())
            ? ""
            : timeUnit()
            }}</span>
        </div>
        }
      </div>

      <!-- <app-icon [name]="isGroupExpanded() ? 'chevronUp' : 'chevronDown'"
        class="w-5 h-5 transition-all duration-300 group-hover:scale-110 text-purple-600 dark:text-purple-400"></app-icon> -->
    </button>
  </div>

  <!-- Date range section start -->

  <!-- @if(isExpanded()){ -->
  <div [@slideInOut]="isExpanded() ? 'open' : 'closed'" [style.pointer-events]="isExpanded() ? 'auto' : 'none'"
    class="absolute top-13 left-0 rounded-xl border bg-white dark:bg-surface-3 border-purple-200 dark:border-line shadow-xl dark:shadow-2xl flex flex-col max-h-[95vh] lg:max-h-[90vh] overflow-hidden w-[864px] max-w-[95vw]"
    #expandedContainer [style.z-index]="1000">
    <div class="flex-1 overflow-y-auto p-2 sm:p-4 lg:p-6 pb-2">
      <div class="flex gap-3 sm:gap-4 lg:gap-6 items-stretch">
        <!-- Left Column - Predefined Ranges -->
        <div class="flex-shrink-0 w-32 sm:w-40 h-[46vh] flex flex-col min-h-0 xs:w-32">
          <h3 class="text-xs sm:text-sm mb-2 text-gray-700 dark:text-gray-300">
            Quick Select
          </h3>

          <!-- Predefined Ranges with Scroll -->
          <div class="space-y-1 h-[100%] overflow-y-auto pr-2 scrollbar-theme">
            @for (range of predefinedRangesList; track $index) {

            <button [ngClass]="{
                'bg-purple-50 dark:bg-purple-500/20 border-purple-300 dark:border-purple-500/30 text-purple-700 dark:text-purple-300':
                  selectedType() === range.label
              }" (click)="selectPreset(range); toggleSection('range')"
              class="w-full cursor-pointer text-left px-2 sm:px-3 py-1.5 sm:py-2.5 rounded-lg text-xs sm:text-sm transition-all duration-200 text-gray-700 dark:text-gray-300 hover:bg-purple-50 dark:hover:bg-white/10 hover:text-purple-700 dark:hover:text-white hover:border-purple-300 dark:hover:border-line-strong border border-transparent"
              type="button">
              {{ range.label }}
            </button>
            }
          </div>
        </div>

        <!-- Right Column - Controls -->
        @if(!hideRightSection){
        <div class="flex-1 min-w-0 flex flex-col space-y-2 sm:space-y-4">
          <div>
            @if(expandedSection() === 'range'){

            <div class="rounded-xl border-purple-200 dark:border-line transition-all duration-300">
              <!-- Date Inputs -->
              <div class="grid grid-cols-2 gap-2 sm:gap-4 mb-2 sm:mb-4">
                <div class="relative">
                  <label class="text-[10px] sm:text-xs mb-1 sm:mb-2 block text-gray-600 dark:text-gray-400">Start
                    Date</label>
                  <div class="relative">
                    <app-icon name="clock"
                      class="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400 pointer-events-none"></app-icon>
                    <input #startDate type="text" [value]="
                        formatInputDate(dayjs.utc(selectedRange().start))
                      " (keyup)="autoFormatStartDate($any($event))" (keydown.enter)="
                        onStartDateChange($any($event).target.value)
                      " placeholder="MM-DD-YYYY" maxlength="10"
                      class="w-full pl-10 pr-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/80 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none" />
                  </div>
                </div>
                <div>
                  <label class="text-[10px] sm:text-xs mb-1 sm:mb-2 block text-gray-600 dark:text-gray-400">End
                    Date</label>
                  <div class="relative">
                    <app-icon name="clock"
                      class="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400 pointer-events-none"></app-icon>
                    <input #endDate type="text" [value]="formatInputDate(dayjs.utc(selectedRange().end))"
                      (keyup)="autoFormatEndDate($any($event))" (keydown.enter)="
                        onEndDateChange($any($event).target.value)
                      " placeholder="MM-DD-YYYY" maxlength="10"
                      class="w-full pl-10 pr-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/80 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none" />
                  </div>
                </div>
              </div>

              <!-- Dual Calendar -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4 mb-2 sm:mb-4">
                <div
                  class="p-2 sm:p-4 rounded-lg border bg-white dark:bg-gray-800/60 border-gray-200 dark:border-line"
                  (mouseleave)="clearHover()">
                  <div class="flex gap-2 mb-2 sm:mb-4">
                    <div class="relative flex-1" appClickOutside (appClickOutside)="isStartMonthOpen.set(false)">
                      <button type="button" (click)="toggleStartMonthDropdown()"
                        class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/70 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                        <span>{{
                          monthNames[startCalendarMonth().month()]
                          }}</span>
                        <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isStartMonthOpen()" fill="none"
                          stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      @if (isStartMonthOpen()) {
                      <div
                        class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-48 overflow-y-auto scrollbar-theme">
                        <!-- Scrollable, max height 48 -->
                        @for (month of monthNames; track $index; let i = $index)
                        {
                        <button type="button" (click)="setStartMonthAndClose(i)" [disabled]="!isStartMonthValid(i)"
                          class="w-full text-left px-3 py-2 dark:text-white text-black text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                          [class.font-medium]="
                            i === startCalendarMonth().month()
                          ">
                          {{ month }}
                        </button>
                        }
                      </div>
                      }
                    </div>

                    <div class="relative" appClickOutside (appClickOutside)="isStartYearOpen.set(false)">
                      <button type="button" (click)="toggleStartYearDropdown()"
                        class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none gap-2">
                        <span>{{ startCalendarMonth().year() }}</span>
                        <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isStartYearOpen()" fill="none"
                          stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      @if (isStartYearOpen()) {
                      <div
                        class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-40 overflow-y-auto">
                        @for (year of getYearOptions(); track year) {
                        <button type="button" (click)="setStartYearAndClose(year)" [disabled]="!isStartYearValid(year)"
                          class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                          [class.font-medium]="
                            year === startCalendarMonth().year()
                          ">
                          {{ year }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>

                  <!-- Navigation Buttons -->
                  <div class="flex items-center justify-between mb-3">
                    <button (click)="previousMonth()" [disabled]="isPrevDisabled()"
                      class="p-1 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
                      type="button">
                      <app-icon name="chevronLeft" class="w-4 h-4"></app-icon>
                    </button>
                    <div class="text-sm text-gray-900 dark:text-white">
                      {{ monthNames[startCalendarMonth().month()] }}
                      {{ startCalendarMonth().year() }}
                    </div>
                    <button (click)="nextMonth()"
                      class="p-1 rounded-lg transition-colors text-gray-700 dark:text-gray-300" type="button">
                      <app-icon name="chevronRight" class="w-4 h-4"></app-icon>
                    </button>
                  </div>

                  <!-- Weekday Headers -->
                  <div class="grid grid-cols-7 gap-1 mb-2">
                    @for (day of weekDays; track $index) {

                    <div class="text-center text-xs py-1 text-gray-600 dark:text-gray-500">
                      {{ day }}
                    </div>
                    }
                  </div>

                  <!-- Days Grid -->
                  <div class="grid grid-cols-7 gap-1">
                    @for (day of currentMonthDays(); track $index) {

                    <button (click)="day.isCurrentMonth ? onDayClick(day.date) : null" (mouseenter)="
                        day.isCurrentMonth ? onDateHover(day.date) : null
                      " [disabled]="day.isDisabled || !day.isCurrentMonth" [class]="
                        'h-7 sm:h-8 rounded-lg text-xs sm:text-sm transition-all duration-200 relative ' +
                        getDayClasses(day)
                      " type="button">
                      {{ day.date.date() }}

                      @if(day.isToday && !day.isStartDate && !day.isEndDate){
                      <div
                        class="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-600 dark:bg-purple-500">
                      </div>
                      }
                    </button>
                    }
                  </div>
                </div>

                <!-- Next Month Calendar -->
                <div
                  class="p-2 sm:p-4 rounded-lg border bg-white dark:bg-gray-800/60 border-gray-200 dark:border-line"
                  (mouseleave)="clearHover()">
                  <div class="flex gap-2 mb-2 sm:mb-4">
                    <!-- END MONTH Dropdown -->
                    <div class="relative flex-1" appClickOutside (appClickOutside)="isEndMonthOpen.set(false)">
                      <button type="button" (click)="toggleEndMonthDropdown()"
                        class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/70 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                        <span>{{
                          monthNames[endCalendarMonth().month()]
                          }}</span>
                        <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isEndMonthOpen()" fill="none"
                          stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      @if (isEndMonthOpen()) {
                      <div
                        class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-48 overflow-y-auto scrollbar-theme">
                        @for (month of monthNames; track $index; let i = $index)
                        {
                        <button type="button" (click)="setEndMonthAndClose(i)" [disabled]="!isEndMonthValid(i)"
                          class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                          [class.font-medium]="i === endCalendarMonth().month()">
                          {{ month }}
                        </button>
                        }
                      </div>
                      }
                    </div>

                    <div class="relative" appClickOutside (appClickOutside)="isEndYearOpen.set(false)">
                      <button type="button" (click)="toggleEndYearDropdown()"
                        class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none gap-2">
                        <span>{{ endCalendarMonth().year() }}</span>
                        <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isEndYearOpen()" fill="none"
                          stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      @if (isEndYearOpen()) {
                      <div
                        class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-purple-200 dark:border-line rounded-lg shadow-lg max-h-40 overflow-y-auto scrollbar-theme">
                        @for (year of getYearOptions(); track year) {
                        <button type="button" (click)="setEndYearAndClose(year)" [disabled]="!isEndYearValid(year)"
                          class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                          [class.font-medium]="
                            year === endCalendarMonth().year()
                          ">
                          {{ year }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>

                  <!-- Month Display -->
                  <div class="flex items-center justify-between mb-3">
                    <button (click)="nextMonth()"
                      class="p-1 rounded-lg transition-colors text-gray-700 dark:text-gray-300" type="button">
                      <app-icon name="chevronLeft" class="w-4 h-4"></app-icon>
                    </button>
                    <div class="text-sm text-gray-900 dark:text-white">
                      {{ monthNames[endCalendarMonth().month()] }}
                      {{ endCalendarMonth().year() }}
                    </div>
                    <button (click)="nextMonth()" [disabled]="isNextDisabled()"
                      class="p-1 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
                      type="button">
                      <app-icon name="chevronRight" class="w-4 h-4"></app-icon>
                    </button>
                  </div>

                  <!-- Weekday Headers -->
                  <div class="grid grid-cols-7 gap-1 mb-2">
                    @for (day of weekDays; track $index) {

                    <div class="text-center text-xs py-1 text-gray-600 dark:text-gray-500">
                      {{ day }}
                    </div>
                    }
                  </div>

                  <!-- Days Grid -->
                  <div class="grid grid-cols-7 gap-1">
                    @for (day of nextMonthDays(); track $index) {

                    <button (click)="day.isCurrentMonth ? onDayClick(day.date) : null" (mouseenter)="
                        day.isCurrentMonth ? onDateHover(day.date) : null
                      " [disabled]="day.isDisabled || !day.isCurrentMonth" [class]="
                        'h-7 sm:h-8 rounded-lg text-xs sm:text-sm transition-all duration-200 relative ' +
                        getDayClasses(day)
                      " type="button">
                      {{ day.date.date() }}

                      @if(day.isToday && !day.isStartDate && !day.isEndDate){
                      <div
                        class="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-600 dark:bg-purple-500">
                      </div>
                      }
                    </button>
                    }
                  </div>
                </div>
              </div>

            </div>
            }
          </div>
        </div>
        } @if(hideRightSection){
        <div class="flex-1 min-w-0 flex flex-col space-y-4">
          <div class="grid grid-cols-2 gap-3 items-start h-full">
            <app-dropdown type="datepicker" placeholder="Select Start Month" [minYear]="minYear || 2017"
              [maxYear]="maxYear || currentYear" [maxMonth]="currentMonth" [selectedValue]="selectedStartDate"
              (selectionChange)="onDateRangeFilter($event, 'start')"></app-dropdown>

            <app-dropdown type="datepicker" placeholder="Select End Month"
              [minYear]="selectedStartDate?.year ?? minYear ?? 2017" [minMonth]="$safeNavigationMigration(selectedStartDate?.month)"
              [maxYear]="maxYear || currentYear" [maxMonth]="currentMonth" [selectedValue]="selectedEndDate"
              [disabled]="!selectedStartDate" (selectionChange)="onDateRangeFilter($event, 'end')"></app-dropdown>
          </div>
        </div>
        }
      </div>
    </div>
    @if(expandedSection() === 'range' || hideRightSection){
    <div
      class="p-2 sm:p-4 lg:p-6 pt-2 sm:pt-3 border-t border-purple-100 dark:border-line/50 flex justify-end gap-2 sm:gap-3 bg-white dark:bg-surface-3 z-10 sticky bottom-0">
      <button (click)="close()"
        class="px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm transition-all duration-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600"
        type="button">
        Cancel
      </button>
      <button (click)="applyRange()"
        class="px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm transition-all duration-300 bg-gradient-to-r from-purple-500 to-indigo-500 dark:from-purple-600 dark:to-indigo-600 hover:from-purple-600 hover:to-indigo-600 dark:hover:from-purple-500 dark:hover:to-indigo-500 text-white shadow-lg"
        type="button">
        Apply Range
      </button>
    </div>
    }
  </div>
  <!-- } -->

  <!-- Date range section end -->

  <div [@slideInOut]="isComparisionExpanded() ? 'open' : 'closed'"
    [style.pointer-events]="isComparisionExpanded() ? 'auto' : 'none'"
    class="absolute top-13 left-0 rounded-xl p-0 border bg-white dark:bg-gray-900/95 border-gray-200 dark:border-line shadow-xl dark:shadow-2xl w-[420px] max-w-[90vw] max-h-[90vh] overflow-y-auto scrollbar-theme"
    #expandedComparisionContainer [style.z-index]="1001">
    @if(expandedSection() === 'comparison'){
    <!-- bg-gray-50 dark:bg-gray-800/50 -->
    <div class="mt-3 rounded-xl p-4 border-gray-200 dark:border-line transition-all duration-300">
      <div class="space-y-2 mb-4">
        <!-- No Comparison -->
        <button (click)="setComparisonType('none')" [class]="
            comparisonType() === 'none'
              ? 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-purple-100 dark:bg-purple-500/20 border border-gray-300 dark:border-line text-purple-700 dark:text-purple-300'
              : 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-line text-gray-700 dark:text-gray-300 hover:border-purple-300 dark:hover:border-line-strong'
          " type="button">
          <div class="flex items-center justify-between cursor-pointer">
            <div>
              <div class="text-sm">No Comparison</div>
              <div class="text-xs text-gray-600 dark:text-gray-400">
                View data without comparison
              </div>
            </div>
            @if(comparisonType() === 'none') {
            <app-icon name="check" class="w-5 h-5 text-purple-500"></app-icon>
            }
          </div>
        </button>

        <!-- Previous Period -->
        <button (click)="setComparisonType('previous-period')" [class]="
            comparisonType() === 'previous-period'
              ? 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-purple-100 dark:bg-purple-500/20 border border-gray-300 dark:border-line text-purple-700 dark:text-purple-300'
              : 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-line text-gray-700 dark:text-gray-300 hover:border-purple-300 dark:hover:border-line-strong'
          " type="button">
          <div class="flex items-center justify-between cursor-pointer">
            <div>
              <div class="text-sm">Previous Period</div>
              <div class="text-xs text-gray-600 dark:text-gray-400">
                {{ previousPeriodDates() }}
              </div>
            </div>
            @if(comparisonType() === 'previous-period') {
            <app-icon name="check" class="w-5 h-5 text-purple-500"></app-icon>
            }
          </div>
        </button>

        <!-- Previous Month -->
        @if(dayjs(selectedRange().end).diff(selectedRange().start, 'day') <= 31){ <button
          (click)="setComparisonType('previous-month')" [class]="
            comparisonType() === 'previous-month'
              ? 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-purple-100 dark:bg-purple-500/20 border border-purple-300 dark:border-purple-500/40 text-purple-700 dark:text-purple-300'
              : 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-purple-500/20 text-gray-700 dark:text-gray-300 hover:border-purple-300 dark:hover:border-line-strong'
          " type="button">
          <div class="flex items-center justify-between cursor-pointer">
            <div>
              <div class="text-sm">Previous Month</div>
              <div class="text-xs text-gray-600 dark:text-gray-400">
                {{ previousMonthDates() }}
              </div>
            </div>
            @if(comparisonType() === 'previous-month') {
            <app-icon name="check" class="w-5 h-5 text-purple-500"></app-icon>
            }
          </div>
          </button>
          }

          <!-- Previous Year -->
          <button (click)="setComparisonType('previous-year')" [class]="
            comparisonType() === 'previous-year'
              ? 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-purple-100 dark:bg-purple-500/20 border border-gray-300 dark:border-line text-purple-700 dark:text-purple-300'
              : 'w-full text-left px-4 py-3 rounded-lg transition-all duration-200 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-line text-gray-700 dark:text-gray-300 hover:border-purple-300 dark:hover:border-line-strong'
          " type="button">
            <div class="flex items-center justify-between cursor-pointer">
              <div>
                <div class="text-sm">Previous Year</div>
                <div class="text-xs text-gray-600 dark:text-gray-400">
                  {{ previousYearDates() }}
                </div>
              </div>
              @if(comparisonType() === 'previous-year') {
              <app-icon name="check" class="w-5 h-5 text-purple-500"></app-icon>
              }
            </div>
          </button>
      </div>

      <!-- Custom Comparison Calendars -->

      @if(comparisonType() === 'custom'){
      <div class="space-y-4 pt-4 border-t border-gray-500/20 dark:border-line">
        <!-- Date Inputs -->
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="text-xs mb-2 block text-gray-600 dark:text-gray-400">Comparison Start Date</label>
            <div class="relative">
              <app-icon name="clock"
                class="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400 pointer-events-none"></app-icon>
              <input type="text" [value]="
                  comparisonRange()
                    ? formatInputDate(dayjs.utc(comparisonRange()!.start))
                    : ''
                " (keydown.enter)="
                  onComparisonStartDateChange($any($event).target.value)
                " placeholder="MM-DD-YYYY"
                class="w-full pl-10 pr-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none" />
            </div>
          </div>
          <div>
            <label class="text-xs mb-2 block text-gray-600 dark:text-gray-400">Comparison End Date</label>
            <div class="relative">
              <app-icon name="clock"
                class="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400 pointer-events-none"></app-icon>
              <input type="text" [value]="
                  comparisonRange()
                    ? formatInputDate(dayjs.utc(comparisonRange()!.end))
                    : ''
                " (keydown.enter)="
                  onComparisonEndDateChange($any($event).target.value)
                " placeholder="MM-DD-YYYY"
                class="w-full pl-10 pr-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-900/50 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none" />
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="p-4 rounded-lg border bg-white dark:bg-gray-900/30 border-gray-200 dark:border-line"
            (mouseleave)="clearHover()">
            <div class="flex gap-2 mb-4">
              <div class="relative flex-1" appClickOutside (appClickOutside)="isOpen = false">
                <button type="button" (click)="
                    toggleDropdown();
                    isYearOpen = false;
                    isEndYearOpen.set(false);
                    isEndMonthOpen.set(false)
                  "
                  class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-purple-500/20 text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                  <span>{{ monthNames[startCalendarMonth().month()] }}</span>
                  <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isOpen" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                @if (isOpen) {
                <div
                  class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-48 overflow-y-auto scrollbar-theme">
                  <!-- Scrollable, max height 48 -->
                  @for (month of monthNames; track $index; let i = $index) {
                  <button type="button" (click)="setMonthAndClose(i)"
                    class="w-full dark:text-white text-black text-left px-3 py-2 dark:text-white text-black text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors"
                    [class.font-medium]="i === startCalendarMonth().month()">
                    {{ month }}
                  </button>
                  }
                </div>
                }
              </div>

              <div class="relative" appClickOutside (appClickOutside)="isYearOpen = false">
                <!-- Trigger button – looks like the original <select> -->
                <button type="button" (click)="
                    isYearOpen = !isYearOpen;
                    isOpen = false;
                    isEndYearOpen.set(false);
                    isEndMonthOpen.set(false)
                  "
                  class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                  <span>{{ startCalendarMonth().year() }}</span>
                  <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isYearOpen" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                <!-- Dropdown panel – scrollable, max-height 40 (≈ 10rem) -->
                @if (isYearOpen) {
                <div
                  class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-40 overflow-y-auto scrollbar-theme">
                  @for (year of getYearOptions(); track year) {
                  <button type="button" (click)="setYearAndClose(year)"
                    class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors"
                    [class.font-medium]="year === startCalendarMonth().year()">
                    {{ year }}
                  </button>
                  }
                </div>
                }
              </div>
            </div>

            <!-- Month Display -->
            <div class="flex items-center justify-between mb-3">
              <button (click)="previousMonth()" [disabled]="isPrevDisabled()"
                class="p-1 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
                type="button">
                <app-icon name="chevronLeft" class="w-4 h-4"></app-icon>
              </button>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ monthNames[startCalendarMonth().month()] }}
                {{ startCalendarMonth().year() }}
              </div>
              <button (click)="nextMonth()" class="p-1 rounded-lg transition-colors text-gray-700 dark:text-gray-300"
                type="button">
                <app-icon name="chevronRight" class="w-4 h-4"></app-icon>
              </button>
            </div>

            <!-- Weekday Headers -->
            <div class="grid grid-cols-7 gap-1 mb-2">
              @for( day of weekDays; track $index) {
              <div class="text-center text-xs py-1 text-gray-600 dark:text-gray-500">
                {{ day }}
              </div>
              }
            </div>

            <div class="grid grid-cols-7 gap-1">
              @for (day of currentMonthDays(); track $index) {

              <button (click)="onDayClick(day.date)" (mouseenter)="onDateHover(day.date)" [disabled]="day.isDisabled"
                [class]="
                  'h-8 rounded-lg text-sm transition-all duration-200 relative ' +
                  getDayClasses(day)
                " type="button">
                {{ day.date.date() }}

                @if(day.isToday && !day.isStartDate && !day.isEndDate){
                <div
                  class="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-600 dark:bg-purple-500">
                </div>
                }
              </button>
              }
            </div>
          </div>

          <!-- Comparison Month 2 Calendar -->
          <div class="p-4 rounded-lg border bg-white dark:bg-gray-900/30 border-gray-200 dark:border-line"
            (mouseleave)="clearHover()">
            <div class="flex gap-2 mb-4">
              <div class="relative flex-1" appClickOutside (appClickOutside)="isEndMonthOpen.set(false)">
                <button type="button" (click)="
                    isEndMonthOpen.set(!isEndMonthOpen());
                    isOpen = false;
                    isYearOpen = false;
                    isEndYearOpen.set(false)
                  "
                  class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                  <span>{{ monthNames[endCalendarMonth().month()] }}</span>
                  <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isEndMonthOpen()" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                @if (isEndMonthOpen()) {
                <div
                  class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-48 overflow-y-auto scrollbar-theme">
                  @for (month of monthNames; track $index; let i = $index) {
                  <button type="button" (click)="setEndMonthAndClose(i)" [disabled]="!isEndMonthValid(i)"
                    class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                    [class.font-medium]="i === endCalendarMonth().month()">
                    {{ month }}
                  </button>
                  }
                </div>
                }
              </div>

              <!-- END YEAR Dropdown -->
              <div class="relative" appClickOutside (appClickOutside)="isEndYearOpen.set(false)">
                <button type="button" (click)="
                    isEndYearOpen.set(!isEndYearOpen());
                    isEndMonthOpen.set(false);
                    isOpen = false;
                    isYearOpen = false
                  "
                  class="w-full flex justify-between items-center px-3 py-2 rounded-lg text-sm transition-all duration-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-line text-gray-900 dark:text-white focus:border-purple-400 dark:focus:border-purple-500/50 focus:outline-none">
                  <span>{{ endCalendarMonth().year() }}</span>
                  <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isEndYearOpen()" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                @if (isEndYearOpen()) {
                <div
                  class="absolute z-[1100] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-line rounded-lg shadow-lg max-h-40 overflow-y-auto scrollbar-theme">
                  <!-- Scrollable, max height 40 -->
                  @for (year of getYearOptions(); track year) {
                  <button type="button" (click)="setEndYearAndClose(year)" [disabled]="!isEndYearValid(year)"
                    class="w-full dark:text-white text-black text-left px-3 py-2 text-sm hover:bg-purple-50 dark:hover:bg-white/10 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
                    [class.font-medium]="year === endCalendarMonth().year()">
                    {{ year }}
                  </button>
                  }
                </div>
                }
              </div>
            </div>

            <!-- Month Display -->
            <div class="flex items-center justify-between mb-3">
              <button (click)="previousMonth()"
                class="p-1 rounded-lg transition-colors text-gray-700 dark:text-gray-300" type="button">
                <app-icon name="chevronLeft" class="w-4 h-4"></app-icon>
              </button>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ monthNames[endCalendarMonth().month()] }}
                {{ endCalendarMonth().year() }}
              </div>
              <button (click)="nextMonth()" [disabled]="isNextDisabled()"
                class="p-1 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
                type="button">
                <app-icon name="chevronRight" class="w-4 h-4"></app-icon>
              </button>
            </div>

            <!-- Weekday Headers -->
            <div class="grid grid-cols-7 gap-1 mb-2">
              @for( day of weekDays; track $index) {
              <div class="text-center text-xs py-1 text-gray-600 dark:text-gray-500">
                {{ day }}
              </div>
              }
            </div>
            <div class="grid grid-cols-7 gap-1">
              @for (day of nextMonthDays(); track $index) {

              <button (click)="day.isCurrentMonth ? onDayClick(day.date) : null"
                (mouseenter)="day.isCurrentMonth ? onDateHover(day.date) : null"
                [disabled]="day.isDisabled || !day.isCurrentMonth" [class]="
                  'h-8 rounded-lg text-sm transition-all duration-200 relative ' +
                  getDayClasses(day)
                " type="button">
                {{ day.date.date() }}

                @if(day.isToday && !day.isStartDate && !day.isEndDate){
                <div
                  class="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-600 dark:bg-purple-500">
                </div>
                }
              </button>
              }
            </div>

            <!-- Month Display -->
            <div class="flex items-center justify-between mb-3">
              <button (click)="previousMonth()"
                class="p-1 rounded-lg transition-colors text-gray-700 dark:text-gray-300" type="button">
                <app-icon name="chevronLeft" class="w-4 h-4"></app-icon>
              </button>
              <div class="text-sm text-gray-900 dark:text-white">
                {{ monthNames[endCalendarMonth().month()] }}
                {{ endCalendarMonth().year() }}
              </div>
              <button (click)="nextMonth()" [disabled]="isNextDisabled()"
                class="p-1 rounded-lg transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
                type="button">
                <app-icon name="chevronRight" class="w-4 h-4"></app-icon>
              </button>
            </div>

            <!-- Weekday Headers -->
            <div class="grid grid-cols-7 gap-1 mb-2">
              @for( day of weekDays; track $index) {
              <div class="text-center text-xs py-1 text-gray-600 dark:text-gray-500">
                {{ day }}
              </div>
              }
            </div>
            <div class="grid grid-cols-7 gap-1">
              @for (day of nextMonthDays(); track $index) {

              <button (click)="day.isCurrentMonth ? onDayClick(day.date) : null"
                (mouseenter)="day.isCurrentMonth ? onDateHover(day.date) : null"
                [disabled]="day.isDisabled || !day.isCurrentMonth" [class]="
                  'h-8 rounded-lg text-sm transition-all duration-200 relative ' +
                  getDayClasses(day)
                " type="button">
                {{ day.date.date() }}

                @if(day.isToday && !day.isStartDate && !day.isEndDate){
                <div
                  class="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-600 dark:bg-purple-500">
                </div>
                }
              </button>
              }
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Apply Button Hidden - Direct emission -->
    </div>
    }
  </div>
  <!-- </div>
  </div> -->
  <!-- } -->

  <!-- Comparision range section end -->

  <!-- Group range section start -->

  <div [@slideInOut]="isGroupExpanded() ? 'open' : 'closed'"
    [style.pointer-events]="isGroupExpanded() ? 'auto' : 'none'"
    class="absolute top-13 right-0 rounded-xl border bg-white dark:bg-surface-1 border-gray-200 dark:border-line shadow-xl dark:shadow-2xl w-[240px] max-h-[90vh] overflow-y-auto scrollbar-theme"
    #expandedGroupContainer [style.z-index]="1002">
    <div class="flex-1 min-w-0 flex flex-col space-y-4 p-6 overflow-y-auto">
      <div>
        @if(expandedSection() === 'groupby'){

        <!-- Dropdown List View -->
        <div class="space-y-1">
          @for( unit of availableTimeUnits(); track $index) {
          @if(!hideWeekDayUnit || (unit.value !== 'week' && unit.value !== 'day'
          && unit.value !== 'hour')){

          <button (click)="onTimeUnitChange(unit.value, $index)" [class]="
              timeUnit() === unit.value
                ? 'w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 bg-purple-100 dark:bg-purple-500/20 text-purple-700 dark:text-purple-300 border border-gray-300 dark:border-line cursor-pointer'
                : 'w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 bg-white dark:bg-gray-900/50 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-line hover:border-purple-300 dark:hover:border-line hover:bg-purple-50 dark:hover:bg-white/10 cursor-pointer'
            " type="button">
            <app-icon [name]="unit.icon" class="w-4 h-4 text-current flex-shrink-0"></app-icon>
            <span class="flex-1 text-left">{{ unit.label }} </span>
            @if(timeUnit() === unit.value) {
            <app-icon name="check" class="w-4 h-4 text-purple-600 dark:text-purple-400 flex-shrink-0"></app-icon>
            }
          </button>
          } }
        </div>
        }
      </div>
    </div>
  </div>
  <!-- } -->

  <!-- Group range section end -->
  } @else {
  <!-- Mobile Mode UI - Hosted in MobileSheetComponent -->
  <div class="flex flex-col h-full bg-white dark:bg-surface-1 overflow-hidden relative">
    <div class="flex-1 overflow-y-auto px-6 py-6 pb-32 no-scrollbar">
      <!-- Choose Period Section -->
      <div class="mb-8">
        <label class="block text-base font-bold text-[#141437] mb-4 dark:text-white">Choose Period</label>
        <div class="relative">
          <button (click)="toggleMobilePreset()"
            class="w-full flex items-center justify-between px-4 py-4 bg-white border border-gray-100 rounded-2xl text-sm text-[#141437] hover:border-purple-400 transition-all shadow-sm dark:bg-surface-1 dark:border-line dark:text-white">
            <span class="font-bold text-[#141437] dark:text-white">{{ activePresetLabel() }}</span>
            <app-icon-v2 [name]="isMobilePresetOpen() ? 'chevronUp' : 'chevronDown'" size="18"
              class="text-gray-400 dark:text-white"></app-icon-v2>
          </button>

          <!-- Preset List Dropdown -->
          @if(isMobilePresetOpen()) {
          <div
            class="mt-2 bg-white dark:bg-gray-900 border border-gray-100 dark:border-line rounded-2xl overflow-hidden shadow-2xl z-30 absolute w-full">
            <div class="max-h-80 overflow-y-auto no-scrollbar">
              @for (preset of predefinedRangesList; track preset.label) {
              <button (click)="onMobilePresetClick({label: preset.label, preset: getPresetId(preset.label)})"
                class="w-full px-4 py-4 flex items-center justify-between hover:bg-purple-50 dark:hover:bg-white/10 transition-colors border-b border-gray-100 dark:border-line last:border-0">
                <span class="text-sm font-bold text-[#141437] dark:text-white"
                  [ngClass]="selectedType() === preset.label ? '!text-purple-600 dark:!text-purple-300' : ''">{{
                  preset.label }}</span>
                <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all" [ngClass]="selectedType() === preset.label
                    ? 'border-purple-600 bg-purple-50 dark:bg-purple-900/30'
                    : 'border-gray-200 dark:border-line'">
                  @if(selectedType() === preset.label) {
                  <div class="w-2.5 h-2.5 rounded-full bg-purple-600"></div>
                  }
                </div>
              </button>
              }
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Custom Range Section (Month + Year only) -->
      <div class="mb-8">
        <label class="block text-base dark:text-white font-bold text-[#141437] mb-4">Custom Range</label>
        <div class="bg-white dark:bg-surface-1 rounded-3xl p-5 border border-gray-100 dark:border-line shadow-sm">
          <h3 class="text-sm font-bold text-gray-500 dark:text-white mb-4">Pick Start &amp; End Month</h3>

          <!-- Month/Year Inputs Grid -->
          <div class="grid grid-cols-2 gap-4 mb-6">
            <div class="space-y-2">
              <div
                class="px-4 py-3 rounded-2xl border transition-all cursor-pointer dark:bg-surface-1 dark:border-line"
                [class.bg-purple-50]="isSelectingStart()" [class.border-purple-200]="isSelectingStart()"
                [class.bg-gray-50]="!isSelectingStart()" [class.border-gray-100]="!isSelectingStart()"
                (click)="onMobileSideToggle(true)">
                <label class="block text-[10px] font-bold uppercase tracking-wider mb-0.5"
                  [class.text-purple-600]="isSelectingStart()" [class.text-gray-400]="!isSelectingStart()">Start</label>
                <span class="block text-sm font-bold text-[#141437] dark:text-white">{{ mobileStartDisplay() }}</span>
              </div>
            </div>
            <div class="space-y-2">
              <div
                class="px-4 py-3 rounded-2xl border transition-all cursor-pointer dark:bg-surface-1 dark:border-line"
                [class.bg-purple-50]="!isSelectingStart()" [class.border-purple-200]="!isSelectingStart()"
                [class.bg-gray-50]="isSelectingStart()" [class.border-gray-100]="isSelectingStart()"
                (click)="onMobileSideToggle(false)">
                <label class="block text-[10px] font-bold uppercase tracking-wider mb-0.5"
                  [class.text-purple-600]="!isSelectingStart()" [class.text-gray-400]="isSelectingStart()">End</label>
                <span class="block text-sm font-bold text-[#141437] dark:text-white">{{ mobileEndDisplay() }}</span>
              </div>
            </div>
          </div>

          <!-- Calendar Header -->
          <div class="flex items-center justify-between mb-6">
            <button (click)="changeMobileYear(-1)"
              class="p-2 rounded-xl bg-gray-50 text-gray-500 dark:bg-surface-1 dark:text-white">
              <app-icon-v2 name="chevronLeft" size="18"></app-icon-v2>
            </button>
            <h4 class="text-sm font-bold text-[#141437] dark:text-white">
              @if(mobileView() === 'month') { {{ mobileBrowseDate().year() }} }
              @else { Years }
            </h4>
            <button (click)="changeMobileYear(1)"
              class="p-2 rounded-xl bg-gray-50 dark:bg-surface-1 text-gray-500 dark:text-white">
              <app-icon-v2 name="chevronRight" size="18"></app-icon-v2>
            </button>
          </div>

          <!-- Segmented Control Tabs - Year & Month only -->
          <div class="bg-gray-100 dark:bg-surface-3 rounded-2xl p-1 flex mb-6">
            <button (click)="setMobileView('year')"
              [class]="mobileView() === 'year' ? 'bg-white dark:bg-surface-1 text-purple-600 shadow-sm' : 'text-gray-300'"
              class="flex-1 py-2 text-xs font-bold rounded-xl transition-all">Year</button>
            <button (click)="setMobileView('month')"
              [class]="mobileView() === 'month' ? 'bg-white dark:bg-surface-1 text-purple-600 shadow-sm' : 'text-gray-300'"
              class="flex-1 py-2 text-xs font-bold rounded-xl transition-all">Month</button>
          </div>

          <!-- Calendar Content -->
          @if(mobileView() === 'month') {
          <div class="grid grid-cols-3 gap-3 animate-in fade-in duration-300">
            @for(month of monthNames; track $index) {
            <button (click)="selectMobileMonth($index)" [disabled]="isMobileMonthDisabled($index)"
              [class]="$index === mobileHighlightedMonth() ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/30' : 'bg-gray-50 text-[#141437] dark:text-white dark:bg-surface-1 dark:border-line'"
              class="py-4 rounded-2xl text-sm font-bold transition-all disabled:opacity-40 disabled:cursor-not-allowed">
              {{ month.substring(0, 3) }}
            </button>
            }
          </div>
          }

          @if(mobileView() === 'year') {
          <div class="grid grid-cols-3 gap-3 animate-in fade-in duration-300">
            @for(year of getYearOptions(); track year) {
            <button (click)="selectMobileYear(year)" [disabled]="isMobileYearDisabled(year)"
              [class]="year === mobileHighlightedYear() ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/30' : 'bg-gray-50 text-[#141437] dark:text-white dark:bg-surface-1 dark:border-line'"
              class="py-4 rounded-2xl text-sm font-bold transition-all disabled:opacity-40 disabled:cursor-not-allowed">
              {{ year }}
            </button>
            }
          </div>
          }
        </div>
      </div>

      <!-- Group By Section -->
      @if(showGroupBy) {
      <div class="mb-8">
        <label class="block text-base font-bold text-[#141437] dark:text-white mb-4">Group By</label>
        <div class="relative">
          <button (click)="toggleMobileGroupBy()" type="button"
            class="w-full flex items-center justify-between px-4 py-4 bg-white dark:bg-surface-1 border border-gray-100 dark:border-gray-800 rounded-2xl text-sm text-[#141437] dark:text-white hover:border-purple-400 transition-all shadow-sm">
            <span class="font-bold">{{ selectedGroupByLabel() }}</span>
            <app-icon-v2 [name]="isMobileGroupByOpen() ? 'chevronUp' : 'chevronDown'" size="18"
              class="text-gray-400"></app-icon-v2>
          </button>

          @if (isMobileGroupByOpen()) {
          <div
            class="mt-2 bg-white dark:bg-surface-1 border border-gray-100 dark:border-gray-800 rounded-2xl overflow-hidden shadow-2xl z-30 absolute w-full">
            <div
              class="px-4 py-3 bg-gray-50 dark:bg-surface-1 text-[10px] font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-gray-800">
              Type
            </div>

            @for (unit of groupByOptions(); track unit.value) {
            @if(!hideWeekDayUnit || (unit.value !== 'week' && unit.value !== 'day' && unit.value !== 'hour')) {
            <button type="button" [disabled]="unit.disabled"
              (click)="onTimeUnitChange(unit.value, $index); toggleMobileGroupBy()"
              class="w-full px-4 py-4 flex items-center justify-between transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0"
              [ngClass]="unit.disabled
                ? 'opacity-40 cursor-not-allowed'
                : 'hover:bg-purple-50 dark:hover:bg-white/5'">
              <span class="text-sm font-bold" [ngClass]="unit.disabled
                  ? 'text-gray-300'
                  : (timeUnit() === unit.value
                      ? 'text-purple-600'
                      : 'text-[#141437] dark:text-white')">
                {{ unit.label }}
              </span>
              <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all" [ngClass]="(timeUnit() === unit.value && !unit.disabled)
                  ? 'border-purple-600 bg-purple-50'
                  : 'border-gray-200 dark:border-gray-700'">
                @if (timeUnit() === unit.value && !unit.disabled) {
                <div class="w-2.5 h-2.5 rounded-full bg-purple-600"></div>
                }
              </div>
            </button>
            }
            }
          </div>
          }
        </div>
      </div>
      }

      <!-- Comparison Section -->
      @if(showComparison) {
      <div class="mb-8 pb-4">
        <label class="block text-base font-bold text-[#141437] dark:text-white mb-4">Comparison</label>
        <div class="space-y-3">
          <button (click)="setComparisonType('none')"
            [class]="comparisonType() === 'none' ? 'border-purple-600 bg-purple-50' : 'border-gray-100 bg-white'"
            class="w-full text-left p-4 rounded-2xl border transition-all flex items-center justify-between group">
            <div>
              <div class="text-sm font-bold text-[#141437]" [class.text-purple-600]="comparisonType() === 'none'">No
                Comparison</div>
              <div class="text-[10px] text-gray-300 mt-0.5">View data without comparison</div>
            </div>
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
              [class.border-purple-600]="comparisonType() === 'none'"
              [class.border-gray-200]="comparisonType() !== 'none'">
              @if(comparisonType() === 'none') {
              <div class="w-2.5 h-2.5 rounded-full bg-purple-600"></div>
              }
            </div>
          </button>

          <button (click)="setComparisonType('previous-period')"
            [class]="comparisonType() === 'previous-period' ? 'border-purple-600 bg-purple-50' : 'border-gray-100 bg-white'"
            class="w-full text-left p-4 rounded-2xl border transition-all flex items-center justify-between group">
            <div>
              <div class="text-sm font-bold text-[#141437]"
                [class.text-purple-600]="comparisonType() === 'previous-period'">Previous Period</div>
              <div class="text-[10px] text-gray-300 mt-0.5">{{ previousPeriodDates() }}</div>
            </div>
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
              [class.border-purple-600]="comparisonType() === 'previous-period'"
              [class.border-gray-200]="comparisonType() !== 'previous-period'">
              @if(comparisonType() === 'previous-period') {
              <div class="w-2.5 h-2.5 rounded-full bg-purple-600"></div>
              }
            </div>
          </button>

          <button (click)="setComparisonType('previous-year')"
            [class]="comparisonType() === 'previous-year' ? 'border-purple-600 bg-purple-50' : 'border-gray-100 bg-white'"
            class="w-full text-left p-4 rounded-2xl border transition-all flex items-center justify-between group">
            <div>
              <div class="text-sm font-bold text-[#141437]"
                [class.text-purple-600]="comparisonType() === 'previous-year'">Previous Year</div>
              <div class="text-[10px] text-gray-300 mt-0.5">{{ previousYearDates() }}</div>
            </div>
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
              [class.border-purple-600]="comparisonType() === 'previous-year'"
              [class.border-gray-200]="comparisonType() !== 'previous-year'">
              @if(comparisonType() === 'previous-year') {
              <div class="w-2.5 h-2.5 rounded-full bg-purple-600"></div>
              }
            </div>
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Footer Buttons -->
    <div
      class="absolute bottom-0 left-0 right-0 p-6 bg-white border-t border-gray-100 flex gap-4 z-20 dark:bg-surface-1 dark:border-line">
      <button (click)="clearMobile()"
        class="flex-1 py-4 rounded-2xl border-2 border-purple-600 text-base font-bold text-purple-600 hover:bg-purple-50 transition-all active:scale-[0.98]"
        type="button">
        Clear All
      </button>
      <button (click)="applyRange()"
        class="flex-1 py-4 rounded-2xl bg-purple-600 text-base font-bold text-white shadow-xl shadow-purple-500/30 hover:opacity-90 transition-all active:scale-[0.98]"
        type="button">
        Apply
      </button>
    </div>
  </div>
  }
</div>